import { Grid, styled, Typography } from '@mui/material';
import React from 'react';
import Page from '../../components/Page';
import { StyledTitle } from '../../components/StyledComponents';
import '../MainPage/index.css';

function AboutUsPage() {
  const UlStyle = styled('ul')(({ theme }) => ({
    fontFamily: 'FixelText-Regular !important',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '29px',
    textAlign: 'justify',
    margin: '10px 0px 10px 0px',
    [theme.breakpoints.up('xs')]: {
      fontSize: '18px'
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '20px'
    }
  }));

  return (
    <Page
      title="Про нас"
      description="Ми – українська Social Selling платформа, що поєднала торговий майданчик та соціальну мережу в одному місці через створення довірчих відносин між виробником і покупцем."
      isIndex={true}
      canonical={window.location.origin + window.location.pathname}
      sx={{
        display: 'flex',
        marginTop: '150px',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: 'max-content',
        padding: { xs: '0px 20px 50px', xl: '0px 100px 100px' }
      }}
    >
      {/* <div
        style={{
          height: 'calc(94vh - 230px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      > */}
      <StyledTitle
        variant="h1"
        maxWidth={800}
        sx={{
          lineHeight: '38px !important',
          fontSize: '32px !important',
          textTransform: 'initial !important',
          margin: '0px auto !important'
        }}
        className="bottomBlock-title"
      >
        Про нас
      </StyledTitle>
      <Grid container spacing={2} sx={{ maxWidth: '1240px', mt: 5 }}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: { xs: '18px', xl: '20px' },
              lineHeight: '29px',
              textAlign: 'justify',
              margin: '10px 0px 10px 0px'
            }}
          >
            Ласкаво просимо до Bonfair – комплексної онлайн-платформи, що відтворює атмосферу
            фізичних ярмарків у цифровому форматі. Ми об'єднуємо виробників, споживачів та
            підприємців у єдиній екосистемі, яка сприяє розвитку бізнесу та взаємодії. <br />
            <br />
            Ми прагнемо створити зручний та ефективний простір, де виробники можуть легко
            демонструвати свою продукцію, мінімізуючи витрати часу та ресурсів на маркетинг. Наша
            платформа допомагає розширювати охоплення та забезпечує максимальну доступність товарів
            на національному рівні.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontSize: 32, fontFamily: 'FixelText-Regular' }}>Наша місія</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: { xs: '18px', xl: '20px' },
              lineHeight: '29px',
              textAlign: 'justify',
              margin: '10px 0px 10px 0px'
            }}
          >
            Усунути інформаційні бар’єри між виробниками та споживачами, сприяючи формуванню
            довірчих відносин через соціальну взаємодію. Це допомагає бізнесам масштабуватися та
            виходити за межі локальних ярмарків, отримуючи нові можливості для зростання
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontSize: 32, fontFamily: 'FixelText-Regular' }}>
            Що ми створили?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: { xs: '18px', xl: '20px' },
              lineHeight: '29px',
              textAlign: 'justify',
              margin: '10px 0px 10px 0px'
            }}
          >
            Ми не просто платформа для продажу – ми інтерактивне середовище, яке поєднує комерцію та
            соціальну взаємодію. Тут ви можете:
          </Typography>
          <UlStyle>
            <br />
            <li>Продавати та купувати – зручний маркетплейс для виробників і споживачів.</li>
            <li>
              Спілкуватися та ділитися досвідом – знайомтеся, ділиться процесом створення, заводьте
              друзів, обговорюйте тренди.
            </li>
            <li>Знаходити партнерів – об'єднуйтеся для реалізації спільних проєктів.</li>
          </UlStyle>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontSize: 32, fontFamily: 'FixelText-Regular' }}>
            Хто створив нашу платформу?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: { xs: '18px', xl: '20px' },
              lineHeight: '29px',
              textAlign: 'justify',
              margin: '10px 0px 10px 0px'
            }}
          >
            Bonfair була заснована командою ентузіастів та експертів у сфері технологій. Наші
            розробники об’єднали свої зусилля, щоб створити інноваційне рішення, яке допомагає
            виробникам легко виходити на ринок. Ми прагнемо підвищувати галузеві стандарти,
            впроваджуючи передові рішення, які допомагають бізнесам успішно розвиватися в цифрову
            епоху. Ми віримо, що цифрові технології можуть зробити бізнес більш доступним та
            успішним для всіх. <br /> <br />
            Адміністрація Сайту - Товариство з обмеженою відповідальністю «Б&Б Рішення» , ЄДРПОУ
            44686788. Адреса місцезнаходження: Україна, місто Одеса.
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: '20px' }}>
          <Typography
            sx={{
              fontSize: 32,
              fontFamily: 'FixelText-Regular',
              textAlign: 'center',
              maxWidth: '93%'
            }}
          >
            Приєднуйтесь до Bonfair вже сьогодні та станьте частиною спільноти ярмарку нового
            покоління, що відкриває нові можливості для всіх учасників!
          </Typography>
        </Grid>
      </Grid>
    </Page>
  );
}

export default AboutUsPage;
